import * as action_types from "./constants";
import { GetClientType, GetCrewDetailType } from "./types";

export type myCompanyState = {
  subListData: {
    loader: boolean;
    data: [] | null;
    count: number;
  };
  SubDetailData: {
    loader: boolean;
    data: GetClientType | null;
  };
  crewFormData: {
    category: { label: string; value: string }[];
    employees: { label: string; value: string; position_id: string }[];
    service_line: { label: string; value: string }[];
  };
  crewListData: {
    loader: boolean;
    data: [] | null;
    count: number;
  };
  crewDetailData: {
    loader: boolean;
    data: GetCrewDetailType | null;
  };
};

const initialState: myCompanyState = {
  subListData: {
    loader: true,
    data: null,
    count: 0,
  },
  SubDetailData: {
    loader: true,
    data: null,
  },
  crewFormData: {
    category: [],
    employees: [],
    service_line: [],
  },
  crewListData: {
    loader: true,
    data: null,
    count: 0,
  },
  crewDetailData: {
    loader: true,
    data: null,
  },
};

type MyCompanyActionType =
  | {
      type: typeof action_types.GET_SUBCONTRACTOR_LISTING;
      data: { payload: []; loading: boolean; count: number };
    }
  | {
      type: typeof action_types.GET_SUBCONTRACTOR_DETAIL;
      data: { payload: GetClientType; loading: boolean };
    }
  | {
      type: typeof action_types.CREW_FORM_DATA;
      data: {
        category: { label: string; value: string }[];
        employees: { label: string; value: string; position_id: string }[];
        service_line: { label: string; value: string }[];
      };
    }
  | {
      type: typeof action_types.GET_CREW_LISTING;
      data: { payload: []; loading: boolean; count: number };
    }
  | {
      type: typeof action_types.GET_CREW_DETAIL;
      data: { payload: GetCrewDetailType; loading: boolean };
    };

const myCompanyReducer = (
  state = initialState,
  action: MyCompanyActionType
): myCompanyState => {
  const { type, data } = action;
  switch (type) {
    case action_types.GET_SUBCONTRACTOR_LISTING:
      return {
        ...state,
        subListData: {
          loader: data?.loading,
          data: data?.payload,
          count: data?.count,
        },
      };

    case action_types.GET_SUBCONTRACTOR_DETAIL:
      return {
        ...state,
        SubDetailData: { data: data?.payload, loader: data?.loading },
      };

    case action_types.CREW_FORM_DATA:
      return {
        ...state,
        crewFormData: data,
      };

    case action_types.GET_CREW_LISTING:
      return {
        ...state,
        crewListData: {
          loader: data?.loading,
          data: data?.payload,
          count: data?.count,
        },
      };

    case action_types.GET_CREW_DETAIL:
      return {
        ...state,
        crewDetailData: { data: data?.payload, loader: data?.loading },
      };

    default:
      return state;
  }
};

export default myCompanyReducer;
